export default __webpack_public_path__ + "static/media/appon.67332ae3.png";